import { render, staticRenderFns } from "./HotelsCarousel.vue?vue&type=template&id=9dddcc20"
import script from "./HotelsCarousel.vue?vue&type=script&lang=js"
export * from "./HotelsCarousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports